import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import { useTimeContext } from 'time-context';
import styled from 'styled-components';
import { useSettingsContext } from '@mono/platmap-settings-context';

export const TimeLabel = () => {
    const { selectedTime } = useTimeContext();
    const { settings } = useSettingsContext();

    const selectedTimeWithTimezone = useMemo(() => {
        if (!selectedTime) return undefined;
        return DateTime.fromISO(selectedTime).setZone(settings.timezone);
    }, [selectedTime, settings.timezone]);

    if (!selectedTimeWithTimezone) return <></>;

    return (
        <Container>
            <div style={{ lineHeight: '22px', color: '#172344', flex: 1 }}>
                <span style={{ fontWeight: 700 }}>{selectedTimeWithTimezone.toFormat(settings.use12HourTimeFormat ? 'h:mm' : 'H:mm')}</span>
                {settings.use12HourTimeFormat && <span>{selectedTimeWithTimezone.toFormat('a').toLocaleLowerCase()}</span>}
            </div>
            <div style={{ fontSize: 14, whiteSpace: 'nowrap', lineHeight: '22px', color: '#595959', flex: 1 }}>
                {selectedTimeWithTimezone.toFormat('dd MMM')}
            </div>
        </Container>
    );
};

export const LiveLabel = () => {
    return <Container>Live</Container>;
};

const Container = styled.div`
    font-family:
        Open Sans,
        sans-serif;
    font-size: 16px;
    text-align: center;
    display: flex;
    flex-direction: row;
    gap: 8px;
    line-height: 12px;
    justify-content: center;
    padding: 8px 16px;
    border-radius: 37px;
    background-color: white;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
`;
